import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Input } from '../Input';
import { Button } from '../Button';
import { Icon } from '../Icon';
import CustomLink from '../CustomLink';
import { PRIVACY_POLICY_LINK } from '../../shared/links';
import { useSendResults } from '../../shared/use-send-results';
import styles from './EmailSlideV3.css';

function EmailSlideV3({ setEmail, onContinue, planLabel = 'Digital Protection Plan' }) {
    const emailRef = useRef(null);
    const afterSuccessfulSendResults = callback => {
        document.getElementById('root').scrollIntoView({ block: 'start', behavior: 'smooth' });

        callback(); /* eslint-disable-line */
        onContinue();
    };

    const { fields, changeField, isPending, submitForm, errors } = useSendResults(setEmail, afterSuccessfulSendResults);
    const isDidYouMean = Boolean(errors.form?.didYouMean);

    useEffect(() => {
        setTimeout(() => {
            emailRef.current?.focus();
        }, 50);
    }, []);

    return (
        <form
            className={styles.root}
            onSubmit={submitForm}
        >
            <h1 className={`${styles.title} main-title`}>
                Enter your email <br />
                to get your personal <br />
                <span>{planLabel}</span>
            </h1>
            <Input
                value={fields.email}
                name='email'
                onChange={changeField}
                className={styles.input}
                placeholder='Enter your email'
                errorText={errors.email || (!isDidYouMean && errors.form?.message)}
                disabled={isPending}
                inputProps={{ autoComplete: 'email', type: 'email', inputMode: 'email' }}
                emailDomainSuggestions={{
                    list: ['gmail.com', 'yahoo.com', 'icloud.com', 'hotmail.com', 'aol.com', 'outlook.com', 'comcast.net', 'att.net', 'live.com', 'mail.com', 'msn.com']
                }}
                inputRef={emailRef}
                iconName='mail'
                didYouMean={errors.form?.didYouMean}
            />
            <div className={styles.agreementBlock}>
                <Icon name='lock' />
                <span>
                    {'We respect your privacy and are committed to protecting your personal data. Your data will be processed in accordance with our '}
                    <CustomLink
                        to={PRIVACY_POLICY_LINK}
                        target='_blank'
                    >
                        Privacy&nbsp;Policy
                    </CustomLink>
                    .
                </span>
            </div>
            <div className={styles.footer}>
                <div className={styles.footerWrapper}>
                    <Button
                        label='Continue'
                        className={styles.button}
                        isLoading={isPending}
                        inSlide
                        buttonProps={{ type: 'submit' }}
                    />
                </div>
            </div>
        </form>
    );
}

EmailSlideV3.propTypes = {
    setEmail: PropTypes.func.isRequired,
    onContinue: PropTypes.func.isRequired
};

export {
    EmailSlideV3
};
